import {
  SPARTAN_ENGINE_SPEC_LABELS,
  SPARTAN_ENGINE_SPEC_UNITS,
} from '@/app/lcv/components/sections/spartan/shared/engine-spec/constants';

export const SPARTAN_LINEUP_SECTION_ID = 'model-lineup';

export const SPARTAN_LINEUP_CONTROLS_REVEAL_OFFSET = '0%,0';

export const SPARTAN_LINEUP_DARK_SECTION_CLASS_NAME =
  'bg-[linear-gradient(180deg,#363636_0%,#321309_100%)]';

export const SPARTAN_LINEUP_LABELS = {
  detail: 'ดูรายละเอียด',
  compare: 'เปรียบเทียบ',
  engineTabsTitle: 'เครื่องยนต์ดีเซล (Ddi)',
} as const;

export const SPARTAN_LINEUP_ENGINE_SPEC_LABELS = {
  ...SPARTAN_ENGINE_SPEC_LABELS,
  /** Product pages — footnote `*จาก ECO STICKER`. */
  fuelEconomy: 'ประหยัดน้ำมัน*',
  /** Engine page — footnote `**จาก ECO STICKER` (`*` is 3.0L compare). */
  fuelEconomyEnginePage: 'ประหยัดน้ำมัน*',
} as const;

export const SPARTAN_LINEUP_ENGINE_SPEC_UNITS = {
  ...SPARTAN_ENGINE_SPEC_UNITS,
  fuelEconomy: 'km/L',
} as const;
